var map = {
	"./access_bank.svg": "ee34",
	"./access_bank_(diamond).svg": "dd72",
	"./alat_by_wema.svg": "87d7",
	"./ecobank_nigeria.svg": "2740",
	"./fidelity_bank.svg": "d958",
	"./first_bank_of_nigeria.svg": "79dd",
	"./first_city_monument_bank.svg": "983a",
	"./guaranty_trust_bank.svg": "e303",
	"./heritage_bank.svg": "4923",
	"./keystone_bank.svg": "a1f9",
	"./polaris_bank.svg": "e6b6",
	"./stanbic_ibtc_bank.svg": "6cec",
	"./standard_chartered_bank.svg": "19dd",
	"./sterling_bank.svg": "7a9d",
	"./test_bank.svg": "157f",
	"./union_bank_of_nigeria.svg": "20b7",
	"./united_bank_for_africa.svg": "c1fc",
	"./wema_bank.svg": "b2a6",
	"./zenith_bank.svg": "a9ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c3e";